import { Instance } from 'mobx-state-tree';
import { RouteStopScheduledDtoModelBase } from './RouteStopScheduledDtoModel.base';

/* The TypeScript type of an instance of RouteStopScheduledDtoModel */
export interface RouteStopScheduledDtoModelType extends Instance<typeof RouteStopScheduledDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopScheduledDtoModel */
export { selectFromRouteStopScheduledDto, routeStopScheduledDtoModelPrimitives, RouteStopScheduledDtoModelSelector } from './RouteStopScheduledDtoModel.base';

/**
 * RouteStopScheduledDtoModel
 *
 * Route scheduling event
 */
export const RouteStopScheduledDtoModel = RouteStopScheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
